import { render } from "./MultiListViewField.vue?vue&type=template&id=0894df22&ts=true"
import script from "./MultiListViewField.vue?vue&type=script&lang=ts"
export * from "./MultiListViewField.vue?vue&type=script&lang=ts"

import "./MultiListViewField.vue?vue&type=style&index=0&id=0894df22&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__